var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPetFriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_4091",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1H31.5V32H0.5V1Z",
    fill: "white",
    stroke: "#A7A3A3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_4091)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6597 8.30563C25.0357 8.71506 24.3104 9.118 23.4752 9.50875C23.4111 9.53875 23.3355 9.53875 23.2714 9.50875C19.3765 7.68669 17.8733 5.5985 17.8733 3.83118C17.8733 2.29118 18.9952 0.96875 20.6232 0.96875C22.1016 0.96875 22.9888 1.81312 23.273 2.13462C23.3264 2.19512 23.42 2.19512 23.4736 2.13462C23.7578 1.81312 24.6448 0.96875 26.1232 0.96875C27.7512 0.96875 28.8733 2.29118 28.8733 3.83118C28.8733 4.84306 28.3805 5.96019 27.2282 7.07226",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9734 22.0574C13.7796 23.0574 14.2653 24.3525 14.2653 25.7669C14.2653 26.9793 13.9078 28.1043 13.2971 29.0312",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.66391 22.0587C3.85828 23.0587 3.37329 24.3531 3.37329 25.7669C3.37329 26.9794 3.73078 28.1043 4.3414 29.0312",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.94849 31.4306C8.23599 31.4807 8.53161 31.5063 8.83223 31.5063C9.13285 31.5063 9.42786 31.4807 9.71537 31.4306",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.473389 12.4562V10.1321C0.473389 8.47086 1.81964 7.1246 3.48088 7.1246C4.16964 7.1246 4.79338 7.40398 5.24464 7.85529C5.48213 8.0928 5.67151 8.37772 5.79839 8.6946",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.45901 17.1398H2.27402C1.27964 17.1398 0.473389 16.3337 0.473389 15.3392V14.4785",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1985 17.1399H15.3829C15.7054 17.1399 16.0079 17.0555 16.2697 16.9061",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8484 8.69393C11.9746 8.37705 12.164 8.09206 12.4015 7.85456C12.8534 7.40331 13.4771 7.12393 14.1659 7.12393C15.8265 7.12393 17.1728 8.47019 17.1728 10.1314V15.3396C17.1728 15.4414 17.164 15.5414 17.1478 15.6383",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.02555 32.0312H2.62329C2.07105 32.0312 1.62329 31.5835 1.62329 31.0312C1.62329 29.9267 2.51873 29.0312 3.62329 29.0312H6.02555C7.13011 29.0312 8.02555 29.9267 8.02555 31.0312C8.02555 31.5835 7.5778 32.0312 7.02555 32.0312Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0255 32.0312H10.6233C10.0711 32.0312 9.62329 31.5835 9.62329 31.0312C9.62329 29.9267 10.5187 29.0312 11.6233 29.0312H14.0255C15.1301 29.0312 16.0255 29.9267 16.0255 31.0312C16.0255 31.5835 15.5778 32.0312 15.0255 32.0312Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3526 18.2414C15.3807 20.5834 13.4378 22.5 11.0986 22.5H6.5595C4.24406 22.5 2.31913 20.6494 2.29851 18.3312C2.2895 17.3178 2.64032 16.3528 3.28006 15.5901C3.63675 15.1649 3.82389 14.6226 3.82389 14.0673V11.7951C3.82389 9.90732 5.35225 8.377 7.23756 8.377H10.4137C12.299 8.377 13.8274 9.90732 13.8274 11.7951V14.067C13.8274 14.6356 14.0347 15.1808 14.3958 15.6197C14.9836 16.3341 15.3406 17.2461 15.3526 18.2414Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82349 17.6253V19.2758",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87329 17.7753C3.87329 18.604 4.54516 19.2758 5.37396 19.2758H12.276C13.1048 19.2758 13.7767 18.604 13.7767 17.7753",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.67334 32.0312V30.9312",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97339 32.0312V30.9312",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6733 32.0312V30.9312",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9734 32.0312V30.9312",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82411 17.6257C7.86129 17.6257 7.07349 16.8381 7.07349 15.8751C7.07349 14.9123 7.86129 14.1245 8.82411 14.1245C9.78691 14.1245 10.5747 14.9123 10.5747 15.8751C10.5747 16.8381 9.78691 17.6257 8.82411 17.6257Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82999 8.37749C8.82999 8.37749 7.17943 13.7805 13.8318 13.7805",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8235 24.2667V27.1349C18.8235 27.9248 19.0372 28.6641 19.411 29.2992",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6456 28.4005C28.5475 28.7173 28.4136 29.0186 28.2483 29.2992",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8235 24.2607V26.4187",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0483 31.4118C23.0703 31.4125 23.0915 31.4125 23.1135 31.4125H24.5571C24.5791 31.4125 24.6003 31.4125 24.6221 31.4118",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8265 24.2601H17.7846C16.8671 24.2601 16.1233 23.5158 16.1233 22.5982V17.8027C16.1233 16.2701 17.3659 15.027 18.8983 15.027C19.0265 15.027 19.1527 15.0376 19.2751 15.0583",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3733 15.0583C28.4957 15.0376 28.6219 15.027 28.7501 15.027C30.2832 15.027 31.5258 16.2702 31.5258 17.8027V22.5984C31.5258 23.5158 30.7819 24.2601 29.8639 24.2601H28.8163",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8467 21.6122C29.8726 23.7709 28.0793 25.5374 25.9204 25.5374H21.7311C19.5942 25.5374 17.8175 23.8319 17.7985 21.6949C17.7902 20.7608 18.114 19.8712 18.7044 19.1683C19.0335 18.7763 19.2063 18.2765 19.2063 17.7646V15.6702C19.2063 13.9301 20.6169 12.5196 22.3571 12.5196H25.2883C27.0284 12.5196 28.439 13.9301 28.439 15.6702V17.7643C28.439 18.2885 28.6303 18.7909 28.9636 19.1955C29.506 19.8541 29.8356 20.6947 29.8467 21.6122Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8235 21.0141V22.5374",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2483 21.1526C19.2483 21.9174 19.8685 22.5374 20.6334 22.5374H27.0035C27.7686 22.5374 28.3886 21.9174 28.3886 21.1526",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8142 21.0133C22.9255 21.0133 22.1985 20.2861 22.1985 19.3976C22.1985 18.509 22.9255 17.7819 23.8142 17.7819C24.7028 17.7819 25.4298 18.509 25.4298 19.3976C25.4298 20.2861 24.7028 21.0133 23.8142 21.0133Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.816 12.5197C23.816 12.5197 22.2926 17.5 28.4323 17.5",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1721 32.0274H18.0834C17.5809 32.0274 17.1733 31.6198 17.1733 31.1173C17.1733 30.112 17.9882 29.297 18.9935 29.297H21.262C22.2671 29.297 23.0821 30.112 23.0821 31.1171C23.0821 31.6198 22.6746 32.0274 22.1721 32.0274Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5722 32.0274H25.4836C24.981 32.0274 24.5735 31.6198 24.5735 31.1173C24.5735 30.112 25.3884 29.297 26.3936 29.297H28.6621C29.6672 29.297 30.4823 30.112 30.4823 31.1171C30.4823 31.6198 30.0748 32.0274 29.5722 32.0274Z",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0735 32.0274V31.0261",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1985 32.0274V31.0261",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4485 32.0274V31.0261",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5735 32.0274V31.0261",
    stroke: "#A7A3A3",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetFriendly);
export default __webpack_public_path__ + "static/media/pet_friendly.597237bc7d4667dc6929e855552051f1.svg";
export { ForwardRef as ReactComponent };